import { call, all, put, takeLatest } from 'redux-saga/effects';
import { getDataFromService, postData } from '../../services/apiGateway';
import { getStartupPageSuccess, getStartupPageFailure, cannotInvestSuccess, cannotInvestFailure } from './actions';

import { GET_STARTUP_PAGE_ATTEMPT, CANNOT_INVEST_ATTEMPT } from './actionTypes';

function* getStartupPageSaga(action) {
  try {
    const startupPage = yield call(
      getDataFromService,
      '/iangels/startups/' + (action.isChild ? 'child-startup-page' : 'startup-page') + `/${action.slug}`
    );
    yield put(getStartupPageSuccess(startupPage?.data));
  } catch (errorCode) {
    yield put(getStartupPageFailure(errorCode.response || errorCode));
  }
}

function* cannotInvestSaga(data) {
  try {
    yield call(postData, '/iangels/startups/cannot-invest', data);
    yield put(cannotInvestSuccess());
  } catch (errorCode) {
    yield put(cannotInvestFailure(errorCode.response || errorCode));
  }
}

function* startupPageSage() {
  yield all([takeLatest(GET_STARTUP_PAGE_ATTEMPT, getStartupPageSaga),
      takeLatest(CANNOT_INVEST_ATTEMPT, cannotInvestSaga)]);
}

export default startupPageSage;
